<!-- Do not change this file. -->
<!-- v-html should never be used for student-authored data. -->

<template>
  <div
    :class="`alert
      alert-${type}
      border-${borderWidth} border-${type}
      text-start text-dark
      shadow-sm
      `"
    role="alert"
  >
    <div class="fw-bold mb-1">{{ title }}</div>
    <!-- v-html should never be used for student-authored data. -->
    <div v-html="content"></div>
    <!-- When student data is authored, use slots -->
    <slot></slot>
  </div>
</template>

<script>
/* Do not change this file. */

export default {
  name: "CustomAlert",
  props: {
    title: {
      type: String,
      default: "Instructions"
    },
    content: {
      type: String
    },
    type: {
      type: String,
      required: false,
      default: "primary",
      validator: (value) => {
        return [
          "primary",
          "secondary",
          "warning",
          "success",
          "danger"
        ].includes(value);
      }
    },
    borderWidth: {
      type: Number,
      required: false,
      default: 1,
      validator: (value) => {
        return [1, 2, 3, 4, 5].includes(value);
      }
    }
  }
};
</script>
